import { useApiQuery } from '../../../../infra/api';
import { endpoints } from '../../network';
import { getViewerIdAndKind, useSession } from '../../../../infra/session';
export var useCampaignDetails = function (campaignId, fetchContents) {
    if (fetchContents === void 0) { fetchContents = false; }
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var _a = useApiQuery({
        endpoint: endpoints.campaignByIdQuery,
        payload: {
            ownerType: viewerIdAndKind.kind,
            ownerId: viewerIdAndKind.id,
            campaignId: campaignId,
        },
        options: {
            enabled: !!campaignId,
        },
    }), campaign = _a.data, isCampaignLoading = _a.isLoading;
    var _b = useApiQuery({
        endpoint: endpoints.campaignContentsByIdQuery,
        payload: {
            campaignId: campaignId,
        },
        options: {
            enabled: !!campaignId && fetchContents,
        },
    }), campaignContents = _b.data, isCampaignContentsLoading = _b.isLoading;
    return {
        campaign: campaign,
        campaignContents: campaignContents,
        isLoading: isCampaignContentsLoading || isCampaignLoading,
    };
};
